var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('div',{ref:"chartdiv",staticStyle:{"width":"100%","height":"300px","pointer-events":"none"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }